import React from 'react';
import { StyleSheet, View } from 'react-native';
import { BodyText, Button, Image, theme } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

import { PayEmptyStateIllustration } from '../../../../assets';

// ─────────────────────────────────────────────────────────────────────────────

export const ScanInStorePayEmptyState = (
  props: ScanInStorePayEmptyStateProps,
) => {
  const { onPressCta } = props;

  const { t } = useLocalizationContext();

  return (
    <View style={styles.container}>
      <Image
        source={PayEmptyStateIllustration}
        style={styles.illustration}
        resizeMode="cover"
        aria-label={t(
          'scan-in-store.tabs.pay.empty-state-card.illustration-alt',
        )}
      />

      <BodyText sizeMatch={['18']} style={styles.body}>
        {t('scan-in-store.tabs.pay.empty-state')}
      </BodyText>

      <Button
        size="large"
        palette="secondary"
        onPress={onPressCta}
        style={styles.cta}
      >
        {t('scan-in-store.tabs.pay.cta.title')}
      </Button>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    borderRadius: theme.radius.large,
    backgroundColor: theme.colors.QUINOA,
  },
  body: {
    marginVertical: theme.spacing['8'],
    marginHorizontal: theme.spacing['6'],
    textAlign: 'center',
  },
  cta: {
    marginBottom: theme.spacing['8'],
  },
  illustration: {
    width: '100%',
    height: 206,
    borderTopLeftRadius: theme.radius.large,
    borderTopRightRadius: theme.radius.large,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanInStorePayEmptyStateProps = Readonly<{
  onPressCta: () => void;
}>;
